import React from 'react';

const ProfileDetails = ({ user }) => {
  return (
    <div className="info-card profile-card">
      <h2>Profile Details</h2>
      <div className="info-grid">
        <div className="info-item">
          <span className="value">{user.email}</span>
        </div>
        <div className="info-item">
          <span className="value">{user.gender}</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetails;